var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "importForm",
      attrs: {
        model: _vm.model,
        "label-width": "15em",
        "label-position": "left"
      }
    },
    [
      _vm._t("default"),
      _vm.formMode !== "master"
        ? [
            _c("BillingYm", {
              attrs: {
                required: true,
                mode: "edit",
                actualprop: true,
                actualmode: _vm.actualmode
              },
              model: {
                value: _vm.billingYm,
                callback: function($$v) {
                  _vm.billingYm = $$v
                },
                expression: "billingYm"
              }
            })
          ]
        : _vm._e(),
      _c(
        "el-form-item",
        {
          staticClass: "import-mode",
          attrs: { label: "データ取込", prop: "data_capture", required: true }
        },
        [
          _c(
            "el-radio-group",
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.dataCapture,
                    callback: function($$v) {
                      _vm.dataCapture = $$v
                    },
                    expression: "dataCapture"
                  }
                },
                [
                  _vm.dispAllCases()
                    ? _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("全データ入替")
                      ])
                    : _vm._e(),
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("データ追加")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ImportFile", {
        ref: "importFile",
        attrs: {
          label: _vm.label,
          action: _vm.action,
          extension: _vm.extension,
          params: _vm.model
        },
        on: {
          "import-success": _vm.importSuccess,
          "import-error": _vm.importError
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }